import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const prsRolloutSelector = createSelector(testTargetOffersSelector, offers => offers.showPRS || Empty.Object);

export { prsRolloutSelector };
